const LANGUAGE_MAP = {
  hr: 'hr-HR',
  de: 'de-DE',
  it: 'it-IT',
  sl: 'sl-SI',
  nl: 'nl-NL',
  pl: 'pl-PL'
}

const WEBSITE_KEY = 'cbc5ca3f-e64e-443f-a29d-56db1b5267bc'
const SCRIPT_ID = 'cookietractor-script'
const CLOSE_BTN_ID = 'ct-custom-close'
const OPTIONAL_CONSENT_IDS = ['cc-c-functional', 'cc-c-statistics', 'cc-c-marketing']

// X button acts as "Refuse": uncheck optional consents, then save via CookieTractor's own handler
function refuseAll() {
  OPTIONAL_CONSENT_IDS.forEach((id) => {
    const checkbox = document.getElementById(id)
    if (checkbox?.checked) {
      checkbox.checked = false
      checkbox.dispatchEvent(new Event('change', { bubbles: true }))
    }
  })
  document.getElementById('cc-b-custom')?.click()
}

function injectCloseButton() {
  if (document.getElementById(CLOSE_BTN_ID)) return
  const container = document.querySelector('#CookieConsent .cookie-popup > div')
  if (!container) return

  const button = document.createElement('button')
  button.id = CLOSE_BTN_ID
  button.type = 'button'
  button.textContent = 'X'
  button.setAttribute('aria-label', 'Close and refuse cookies')
  button.addEventListener('click', refuseAll)
  container.prepend(button)
}

// Banner is rendered (and re-rendered on "change settings") by CookieTractor, so watch for it
function watchForBanner() {
  new MutationObserver(injectCloseButton).observe(document.body, { childList: true, subtree: true })
  injectCloseButton()
}

function loadCookieTractor(lang) {
  if (document.getElementById(SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.src = 'https://cdn.cookietractor.com/cookietractor.js'
  script.setAttribute('data-lang', LANGUAGE_MAP[lang] || 'en-150')
  script.setAttribute('data-id', WEBSITE_KEY)
  document.head.appendChild(script)
}

export default defineNuxtPlugin(() => {
  const { lang } = useLanguage()

  loadCookieTractor(lang.value)
  watchForBanner()
})
